// @ts-check
/* $ global module plupload pluploadQueue */
'use_strict';

declare var $;
declare var plupload;

import { Notifications } from '../tv_utils/notifications';

/**
 * Class to initialize a plupload queue object and bind its functionality to ui elements.
 */
export class GenericUploadQueue {
    /**
     * @var {[key: string]: any} form_elements dict of related HTMLElements on the dom.
     * @var {string} dispatch url to call once to upload files.
     * @var {string} container changes based on difu.
     * @var {string} blacklist is a list of extensions not allowed to be uploaded.
     * @var {any} upload_queue is the plupload queue initialized.
     * @var {number} items_to_upload is a flag for and number of items needed to upload.
     */
    form_elements: {[key: string]: any};
    dispatch: string;
    container: string = 'upload_queue';
    blacklist: string = '';
    upload_queue: any;
    items_to_upload: number = 0;

    /**
     * The constructor for the class..
     *
     * @param {boolean} difu is Design It For You.
     * @param {string} uploader_id the ID the uploader looks for to initialize.
     * @var {string} order_id is either the Config ID or Inventtrans ID.
     * @var {number} sales_id is needed for an Order and also determines if this is from an order.
     */
    constructor() {
        this.form_elements = {};
        this.dispatch = `${window.location.origin}/index.php?dispatch=tv_artwork.upload_generic`;

        const blacklist_extensions = <HTMLInputElement>document.getElementById('js-blacklist-extensions');
        if (blacklist_extensions) {
            this.blacklist = blacklist_extensions.value;
        } else {
            $.ceAjax('request', 'index.php?dispatch=tv_artwork.get_extensions_blacklist', {
                overlay: false,
                full_render: false,
                method: 'POST',
                hidden: true,
                caching: true,
                callback: results => {
                    this.blacklist = results.blacklist_extensions;
                }
            });            
        }
    }

    /**
     * Binds all of the customer info form elements.
     *
     * @returns {void}
     */
    bind(): void {
        // pluploadQueue.
        this.upload_queue = $(`#${this.container}`).pluploadQueue();

        this.form_elements.form = document.getElementById('js-artwork_upload_form');
        this.form_elements.first_name = document.getElementById('uploader_first_name');
        this.form_elements.last_name = document.getElementById('uploader_last_name');
        this.form_elements.company = document.getElementById('uploader_company');
        this.form_elements.state = document.getElementById('uploader_state');
        this.form_elements.country = document.getElementById('uploader_country');
        this.form_elements.email = document.getElementById('uploader_email');
        this.form_elements.phone = document.getElementById('uploader_phone');
        this.form_elements.extension = document.getElementById('uploader_extension');
        this.form_elements.order_number = document.getElementById('uploader_order_number');
        this.form_elements.message = document.getElementById('uploader_message');
        this.form_elements.button_container = document.querySelector('.plupload_buttons');
        this.form_elements.upload_status = document.querySelector('.plupload_upload_status');
        this.form_elements.uploader_container = document.getElementById(this.container);
        this.form_elements.filelist_container = document.getElementById(`${this.container}_filelist`);
        this.form_elements.start_upload = document.querySelector(`#${this.container} .plupload_start`);

        // CSS fixes that can only occur after the uploader is initialized.
        $('.plupload_filelist_footer').addClass('tv-bottom__down-8');
        $('.plupload_container').addClass('tv-padding__none');
        $('.plupload_content').addClass('tv-position__inherit');
        $('.plupload_droptext').addClass('tv-display__block');

        // Hide the buttons for custom UI effects and Upload Logic.
        this.form_elements.add_files = document.getElementById(`${this.container}_browse`);
        this.form_elements.add_files.style.display = 'none';

        // add_files is an anchor element with href="#". Clicking an anchor tag with href="#" navigates
        // to the top of the page by default, so we want to remove this attribute.
        this.form_elements.add_files.removeAttribute('href');
        this.form_elements.start_upload.removeAttribute('href');

        // Add items to the Items to Upload.
        this.upload_queue.bind('FilesAdded', (up, files) => {
            // Need to be sure the file wasn't filtered out.
            if (up.files.length > 0) {
                this.items_to_upload += 1;
            }

            this.adjust_select_files();
        });

        // Reduce the number of Items to Upload.
        this.upload_queue.bind('FilesRemoved', () => {
            this.items_to_upload -= 1;

            if (this.items_to_upload < 0) {
                this.items_to_upload = 0;
            }

            this.adjust_select_files();
        })

        // Removing tooltip.
        document.getElementById(`${this.container}_container`).removeAttribute('title');

        // Make the entire Plupload Queue a button.
        this.form_elements.uploader_container.addEventListener('click', (e: Event) => {
            // Check if event is trusted to prevent infinite click loop.
            if (e.isTrusted) {
                this.form_elements.add_files.click();
                // Keep the Modal from jumping around.
                const dialog = $.ceDialog('get_last')[0];
                if (dialog) {
                    $.ceDialog('get_last').ceDialog('reload');
                }
            }
        });

        this.form_elements.submit_button = document.getElementById(`artwork-upload-button-submit`);
        if (this.form_elements.submit_button) {
            this.form_elements.submit_button.addEventListener('click', () => {
                this.form_elements.start_upload.click();
            });
        }

        this.adjust_select_files();
    }

    /**
     * Method to Customize Select Files such as Customizing the Drop Text and
     * stopping propagation (or bubbling) on the event of removing a file.
     *
     * @return {void}
     */
     adjust_select_files(): void {
        // Get container height.
        const container_height = this.form_elements.filelist_container.offsetHeight;

        // Get last child element position and height.
        const last_child = <HTMLElement>this.form_elements.filelist_container.lastChild;
        var min_height = 0;
        var vertical_offset = 0;
        if (last_child) {
            min_height = last_child.offsetHeight;
            vertical_offset = last_child.offsetTop + min_height;
        }

        // Calculate max height of plus symbol.
        const height = (container_height - vertical_offset);

        // If there are Items to Upload, add the plus sign.
        if (this.items_to_upload) {
            // Add Plus symbol.
            this.form_elements.filelist_container.insertAdjacentHTML(
                'beforeend',
                `<div class="tv-display__flex tv-width__half tv-margin__auto"
                    style="height:${height}px;min-height:${min_height}px;"
                >
                    <div class="tv-margin__auto tv-text-align__center"><i class="ty-icon-plus"></i></div>
                </div>`
            );
        } else { // Otherwise we need to have the Drag or Click to add Files.
            // Adding custom Drop Text.
            this.form_elements.filelist_container.insertAdjacentHTML(
                'beforeend',
                `<div class="tv-display__flex tv-width__half tv-margin__auto"
                    style="height:${height}px;min-height:${min_height}px;"
                >
                    <div class="tv-margin__auto tv-text-align__center tv-file__upload-text">Drag files here or Click to add files.</div>
                    <i class="fas fa-upload fa-5x tv-file__upload"></i>
                </div>`
            );
        }

        // Add click event to Remove File button to stop it from firing the Browse for File.
        for (const remove_file of document.querySelectorAll('.plupload_file_action a')) {
            remove_file.addEventListener('click', event => {
                event.stopPropagation();
            });
        }
    }

    /**
     * Creates an instance of the plupload queue.
     *
     * @returns {void}
     */
    init_queue(): void {
        $(`#${this.container}`).pluploadQueue({
            runtimes: 'html5',
            max_file_size: '1536mb',
            chunk_size: '5mb',
            dragdrop: true,
            container: this.container,
            url: this.dispatch,
            flash_swf_url: 'js/addons/tv_artwork/Moxie.swf',
            silverlight_xap_url: 'js/addons/tv_artwork/Moxie.xap',
            filters: [],
            rename: true,
            sortable: true,
            init: {
                BeforeUpload: this.validate_upload.bind(this),
                UploadComplete: this.upload_complete.bind(this),
                FileFiltered: this.file_filter.bind(this),
                Error: this.handle_errors.bind(this),
                FileUploaded: this.file_uploaded.bind(this)
            }

        });
    }

    /**
     * File Uploaded Method to allow us to capture info about the file.
     * The Response from PHP will be in info.response.
     * @param {plupload.Uploader} uploader Uploader instance sending the event.
     * @param {plupload.File} file Another file that has to be added to the queue.
     * @param {Object} info is about the request such as its response, status, and headers.
     * @return {void}
     */
    file_uploaded(up, file, info) {
        // Method to Override.
    }

    handle_errors(up, args) {
        // Alert the customer.
        Notifications.set_notification('E', 'Upload Error.', args.message, false);
    }

    /**
     * File Filter for Plupload to not allow certain file extensions and
     * produce a proper warning for file size.
     *
     * @param {plupload.Uploader} uploader Uploader instance sending the event.
     * @param {plupload.File} file Another file that has to be added to the queue.
     * @return {boolean}
     */
    file_filter(up, file) : boolean {
        // Get an array of extensions in our blacklist.
        const b_extensions = this.blacklist.split(',');
        // Get File extension from File Name.
        const file_ext = file.name.split('.').slice(-1)[0];
        // Get File extension from File Type.
        const file_type = file.type.split('/').slice(-1)[0];

        // Check File Extension.
        for (const ext of b_extensions) {
            // If the File Extension is in our Blacklist.
            if (file_ext === ext || file_type === ext) {
                // Alert the customer.
                Notifications.set_notification(
                    'E',
                    'Upload Error.',
                    `File type (extension) not accepted for: ${file.name}`,
                    false
                );
                // Remove the file from the Uploader.
                up.removeFile(file);
                // Respond with false.
                return false;
            }
        }

        // Check File Size.
        if (file.size > up.settings.max_file_size) {
            // Alert the customer.
            Notifications.set_notification(
                'E',
                'Upload Error.',
                `File size over ${up.settings.max_file_size} for: ${file.name}`,
                false
            );
            // Remove the file from the Uploader.
            up.removeFile(file);
            // Respond with false.
            return false;
        }

        return true;
    }

    /**
     * Checks validity of the entered phone number.
     * 
     * @param {HTMLFormElement} phone_input is the phone field for this form.
     */
     phone_validation(phone_input) {
        const phone_validation = /^\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;
        const phone_number = phone_input.value;
        
        phone_input.setCustomValidity('');
        if (!phone_number.match(phone_validation)) {
            phone_input.setCustomValidity(
                "The phone number in the Phone field is invalid. Please enter your phone number in this format: 555-555-5555 or 5555555555."
            );
        }

        phone_input.reportValidity();
    } 

    /**
     * Validates the form fields before the files get uploaded.
     *
     * @returns {boolean}
     */
    validate_upload() : boolean {
        this.phone_validation(this.form_elements.phone); 
        if (!this.form_elements.form.checkValidity()) {
            this.form_elements.form.reportValidity();

            this.form_elements.button_container.style.display = 'inline';
            this.form_elements.upload_status.style.display = 'inline';

            $(`#${this.container}`).pluploadQueue().state = plupload.QUEUED;
            $(`#${this.container}`).pluploadQueue().trigger('StateChanged');

            return false;
        }

        // Set parameters to be passed in request to controller.
        $(`#${this.container}`).pluploadQueue().settings.multipart_params = {
            'firstname': this.form_elements.first_name.value,
            'lastname': this.form_elements.last_name.value,
            'company': this.form_elements.company.value,
            'state': this.form_elements.state.value,
            'country': this.form_elements.country.value,
            'phone': this.form_elements.phone.value,
            'extension': this.form_elements.extension.value,
            'email': this.form_elements.email.value,
            'order_number': this.form_elements.order_number.value,
            'message': this.form_elements.message.value
        };

        // Toggle the Status Box to show.
        $.toggleStatusBox('show', {
            overlay: true,
            statusContent: '<span class="ty-ajax-loading-box-with__text-wrapper">Uploading Artwork</span>',
            statusClass: 'ty-ajax-loading-box_text_block'
        });
    }

    /**
     * Checks that if a file failed uploaded that an error notification is thrown and the upload queue
     * gets reset.
     *
     * @param {plupload.Uploader} uploader_instance for plupload.
     * @param {array} files array of the files that have been uploaded.
     * @returns {void}
     */
    upload_complete(uploader_instance, files): void {
        $.toggleStatusBox('hide');
        let error_found = false;
        // Check to see if the file failed upload and display an error notification.
        for (const file of files) {
            if (file.status === plupload.FAILED) {
                Notifications.set_notification(
                    'E',
                    'Failed to upload artwork.',
                    `An error occurred when uploading ${file.name}`,
                    false
                );
                error_found = true;
                uploader_instance.removeFile(file);
            }
        }

        if (error_found) {
            this.init_queue();
            return;
        }

        Notifications.set_notification(
            'N',
            'Artwork uploaded successfully!',
            'Please check your email for upload confirmation.',
            false
        );

        // Hide upload button and display success message.
        this.form_elements.submit_button.classList.add('tv-display__none');
        const uploaded_message = document.getElementById('js-offline-order-uploaded');
        uploaded_message.classList.remove('tv-display__none');
    }
}
